
export default {
  components: {
    Dialog: () => import('primevue/dialog'),
    Button: () => import('primevue/button'),
    Textarea: () => import('primevue/textarea')
  },
  props: {
    display: { type: Boolean, default: false },
    cid: { type: Number, default: 0 }
  },
  data() {
    return {
      onSubmit: false,
      status: null,
      submitTried: false,
      issueText: ''
    }
  },
  computed: {
    localDisplay: {
      get() {
        return this.display
      },
      set(value) {
        this.$emit('update:display', value)
        if (!value) {
          this.status = null
          this.submitTried = false
          this.issueText = ''
          this.onSubmit = false
        }
      }
    },
    statusMessage() {
      return this.status === 'success' ? this.$t('modals.reportSuccess') : this.$t('error.generic')
    }
  },
  methods: {
    hideModal() {
      this.resetState()
      this.localDisplay = false
    },
    async reportIssue() {
      this.onSubmit = true
      if (this.issueText && this.cid > 0) {
        this.submitTried = false
        try {
          const response = await this.$axios.post('/proxysbapi/auth/user/campaign-issue', {
            cid: this.cid,
            issueText: this.issueText
          })

          this.status = response.status === 200 && response.data.response === 'OK' ? 'success' : 'fail'
        } catch (error) {
          this.status = 'fail'
        }
      } else {
        this.submitTried = true
      }
      this.onSubmit = false
    },
    resetState() {
      this.status = null
      this.submitTried = false
      this.issueText = ''
    }
  }
}
